import { render, staticRenderFns } from "./SecurityIndex.vue?vue&type=template&id=565a5f35&scoped=true&name=SecurityIndex&"
import script from "./SecurityIndex.vue?vue&type=script&lang=js&"
export * from "./SecurityIndex.vue?vue&type=script&lang=js&"
import style0 from "./SecurityIndex.vue?vue&type=style&index=0&id=565a5f35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565a5f35",
  null
  
)

export default component.exports